export const createUiSlice = (set, get) => ({
  // UI state
  isFocused: false,
  wasCleared: false, // Flag to track if output was intentionally cleared

  // UI state setters
  setIsFocused: (focused) => set({ isFocused: focused }),
  setWasCleared: (cleared) => set({ wasCleared: cleared }),

  // Terminal container reference for scrolling
  terminalContainerRef: null,

  // Function to set the terminal container reference
  setTerminalContainer: (ref) => {
    // Store the reference in the store state
    set({ terminalContainerRef: ref });
  },

  // Function to scroll the terminal to bottom - improved version
  scrollToBottomByFocus: () => {
    const { terminalContainerRef } = get();

    // Use requestAnimationFrame and setTimeout to ensure DOM is updated
    requestAnimationFrame(() => {
      setTimeout(() => {
        // First try to scroll the container manually
        if (terminalContainerRef && terminalContainerRef.current) {
          const container = terminalContainerRef.current;
          container.scrollTop = container.scrollHeight;

          // Force a second scroll after a small delay in case content is still updating
          setTimeout(() => {
            container.scrollTop = container.scrollHeight;
          }, 50);
        }

        // Then focus the input as backup and for user experience
        const activeInput = document.querySelector(
          'input[type="text"]:not([disabled])'
        );
        if (activeInput) {
          activeInput.focus();
        }
      }, 50);
    });
  },
});
